import { IRoute, routeConfig, routeConfigHelper } from "./RouteConfig";

export function getRoute(givenRoute: string): IRoute | null {
  const routePermission = routeConfig.find((r) => r.path === givenRoute);
  return routePermission ? routePermission : null;
}

export function getRoutePermission(givenRoute: string): string | undefined {
  const route = routeConfigHelper.getRouteForPath(givenRoute);
  return route ? route.permission : undefined;
}

export function check(permissions: string[], required: string | undefined) {
  return !required || (permissions && permissions.includes(required));
}
